<template>
  <div class="template-wrap p-1">
    <div class="font-bold text-xs">
      {{ data.name }}
    </div>
    <div v-if="data.owner" class="text-xs">
      {{ data.owner.fullName }}
    </div>
  </div>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    filters: {
      formatShortTime(value) {
        return dayjs(value).format('h:mma');
      },
    },

    data() {
      return {
        data: {},
      };
    },

    mounted() {
      // console.log(this.data);
    },
  };
</script>